<template>
  <div class="container-fluid p-0">
    <div class="internet">
      <div class="card px-0 ">
        <spinner class="text-center mt-8 mb-8" v-if="loading" style="height: 200px">
          <div>
            <span class="mt-4">
              <Spinner></Spinner>
            </span>
          </div>
        </spinner>
        <div class="card-body px-0" v-else-if="filteredMembers.length > 0">
          <div class="row">
            <div class="col-md-6 px-4"></div>
            <div class="col-md-6 text-end" style="padding-right: 30px">
              <RouterLink to="/new-account" v-if="filteredMembers.length > 0">
                <argon-button class="py-2" color="success" size="sm" variant="outline">
                  <i class="fas fa-plus me-2"></i>
                  {{ $t("button.add") }}
                </argon-button>
              </RouterLink>
            </div>
          </div>

          <spinner class="text-center mt-8 mb-8" v-if="loading" style="height: 200px">
            <div>
              <span class="mt-4">
                <Spinner></Spinner>
              </span>
            </div>
          </spinner>

          <table class="table px-0 mt-6 mb-6" v-else-if="filteredMembers.length > 0">
            <thead>
              <tr style="border-bottom: 1px solid rgba(255, 255, 255, 0.1)">
                <th scope="col" class="border-0 w-25">{{ $t("accounts.name") }}</th>
                <th scope="col" class="text-start border-0 w-25 px-0" style="transform: translateX(100px)">
                  {{ $t("accounts.phone") }}
                </th>
                <th scope="col" class="text-start  border-0 w-25 px-0" style="transform: translateX(150px)">
                  {{ $t("accounts.role") }}
                </th>
                <th scope="col" class="text-end border-0 w-25" style="padding-right: 30px">
                  {{ $t("accounts.autorisation") }}
                </th>
              </tr>
            </thead>

            <div v-if="loading" class="pt-6" style="width: 150%; height: 250px; margin-left: 100%">
              <Spinner></Spinner>
            </div>

            <tbody>
              <tr v-for="list in filteredMembers" :key="list.id" style="
                  position: relative;
                  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                ">
                <td scope="row" class="px-4 border-0">
                  <div class="d-flex">
                    <Zoomableimage :photoUrl="list.photo" />
                    <span class=" mt-n2 ms-3 " style="transform: translateY(10px);">{{ list.last_name }} <br> {{
                      list.first_name }} </span>
                  </div>
                </td>

                <td class="px-0 border-0" style="transform: translateX(100px)"> <span class="content-td">{{
                  list.username }}</span></td>
                <td class="border-0" style="transform: translateX(120px);">
                  <div class="dropdown pt-1 " style=" height:50px;">
                      <button class="btn  dropdown-toggle" type="button" :id="'dropdownMenuButton' + list.id"
                      data-bs-toggle="dropdown" aria-expanded="false" style="z-index: 1;">
                      <span class="text-white" style="opacity: 0.6; font-size: 16px; font-weight: normal;"> {{
                        list.is_staff ? $t("accounts.admin") : $t("accounts.user") }}</span>
                    </button>
                    <ul class="dropdown-menu pb-0" :aria-labelledby="'dropdownMenuButton' + list.id"
                      style="position: absolute; background-color: white; z-index: 1000;  top: 100%; left: 0;">
                      <li>
                          <a class="dropdown-item" href="#" @click="openmodal(list.id)" data-bs-toggle="modal"
                          :data-bs-target="list.is_staff ? '#staticBackdrop23' : '#staticBackdrop22'"
                          :title="$t('accounts.click_edit_role')">
                          {{ list.is_staff ? $t("accounts.user") : $t('accounts.admin') }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>

                <td class="text-end w-25 position-relative border-0 pt-4 pe-4 ">
                  <span class="amount" style="transform:translateY(20px)" v-if="list.is_active == true">{{ $t("accounts.lock") }}</span>
                  <span class="amount" style="transform:translateY(20px)" v-if="list.is_active == false">{{ $t("accounts.unlock") }}</span>
                  <div class="action p-0 position-absolute top-0 " style="right: -20px;">
                    <!-- Bouton blocage/déblocage -->
                    <button v-if="canSeeLock(list) && list.is_active == true"
                      class="btn btn-link text-secondary mb-0 ms-auto" :title="$t('accounts.block_user')"
                      data-bs-toggle="modal" data-bs-target="#staticBackdrop20" @click="openmodal(list.id)" style="transform: translateX(10px); margin-top: 15px;">
                      <i style="font-size: 18px" class="bi bi-unlock-fill text-success" aria-hidden="true"></i>
                    </button>
                    <button v-if="canSeeLock(list) && list.is_active == false" class="btn btn-link text-secondary mb-0" :title="$t('accounts.unblock_user')" data-bs-toggle="modal" data-bs-target="#staticBackdrop25" @click="openmodal(list.id)" style="transform: translateX(10px); margin-top: 15px;">
                      <i style="font-size: 18px" class="bi bi-lock-fill text-success" aria-hidden="true"></i>
                    </button>
                    <!-- Bouton envoi d'info -->
                    <button class="btn btn-link text-secondary mb-0" :title="$t('accounts.title_icon_send')" @click="memberinfo(list.id)" style="margin-top: 15px; margin-right:20px;">
                      <i style="font-size: 18px" class="fa fa-paper-plane text-success" aria-hidden="true"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="else text-center pb-5" v-else>
            <div class="container">
              <div class="text mt-3">
                <i class="bi bi-exclamation-triangle-fill fs-1 text-warning" style="transform: translateY(50px)"></i>
                <h5 class="mt-4">{{ $t("accounts.no_admin") }}</h5>
                <p class="mt-5">
                  <router-link to="/new-account" class="btn w-20 fs-6 text-center bg-gradient-success"
                    style="width: 200px; z-index: 2">
                    <span class="fa fa-plus-circle m-2"></span>
                    {{ $t("button.add") }}
                  </router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal bloquer -->
  <div class="modal fade" id="staticBackdrop20" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="card">
        <div class="modal-content">
          <div class="modal-header border-0">
            <h5 class="modal-title" id="staticBackdropLabel20"></h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-center pt-4 pb-4">
            <i class="bi bi-exclamation-triangle-fill text-warning fs-2 mb-3"></i>
            <h6>{{ $t("accounts.lock_modal_title") }}</h6>
            <p class="text-justify  px-6" style="margin: 20px auto; width: max-content">
              {{ $t("accounts.lock_modal_text") }}
            </p>
          </div>
          <div class="modal-footer border-0 pb-5 mb-1">
            <argon-button type="button" class="btn bg-transparent  " data-bs-dismiss="modal"
              style="width: 150px; height: 50px; padding-top: 15px; border: 1px solid rgba(255, 255, 255, 0.4);">
              {{ $t("button.cancel") }}
            </argon-button>
            <argon-button :loading="loading" :active="buttonActive || showConfirmation" color="danger"
              variant="gradient" type="button" class="mt-1" style="width: 150px; height: 50px; padding-top: 15px"
              @click="confirmBlockUser(studentToDeleteId)">
              {{ $t("button.confirm") }}
            </argon-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal débloquer -->
  <div class="modal fade" id="staticBackdrop25" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="card">
        <div class="modal-content">
          <div class="modal-header border-0">
            <h5 class="modal-title" id="staticBackdropLabel20"></h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-center pt-4 pb-4">
            <i class="bi bi-exclamation-triangle-fill text-warning fs-2 mb-3"></i>
            <h6>{{ $t("accounts.unlock_modal_title") }}</h6>
            <p class="text-justify px-6" style="margin: 20px auto; width: max-content">
              {{ $t("accounts.unlock_modal_text") }}
            </p>
          </div>
          <div class="modal-footer border-0 pb-5 mb-1">
            <argon-button type="button" class="btn bg-transparent" data-bs-dismiss="modal"
              style="width: 150px; height: 50px; padding-top: 15px ;border: 1px solid rgba(255, 255, 255, 0.4);">
              {{ $t("button.cancel") }}
            </argon-button>
            <argon-button :loading="loading" :active="buttonActive || showConfirmation" color="danger"
              variant="gradient" type="button" class="mt-1" style="width: 150px; height: 50px; padding-top: 15px"
              @click="confirmBlockUser1(studentToDeleteId)">
              {{ $t("button.confirm") }}
            </argon-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal modifier le rôle (admin) -->
  <div class="modal fade" id="staticBackdrop22" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="card">
        <div class="modal-content">
          <div class="modal-header border-0">
            <h5 class="modal-title" id="staticBackdropLabel20"></h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-center pt-4 pb-4">
            <i class="bi bi-exclamation-triangle-fill text-warning fs-2 mb-3"></i>
            <h6> {{ $t("accounts.modal_user_title") }}</h6>
            <p class="text-justify  px-6" style="margin: 20px auto; width: max-content">
              {{ $t("accounts.modal_user_content") }}
            </p>
          </div>
          <div class="modal-footer border-0 pb-5 mb-1">
            <argon-button type="button" class="btn bg-transparent " data-bs-dismiss="modal"
              style="width: 150px; height: 50px; padding-top: 15px; border: 1px solid rgba(255, 255, 255, 0.4);">
              {{ $t("button.cancel") }}
            </argon-button>
            <argon-button :loading="loading" :active="buttonActive || showConfirmation" color="danger"
              variant="gradient" type="button" class="mt-1" style="width: 150px; height: 50px; padding-top: 15px"
              @click="user_admin(studentToDeleteId)">
              {{ $t("button.confirm") }}
            </argon-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal modifier le rôle (user) -->
  <div class="modal fade" id="staticBackdrop23" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="card">
        <div class="modal-content">
          <div class="modal-header border-0">
            <h5 class="modal-title" id="staticBackdropLabel20"></h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-center pt-4 pb-4">
            <i class="bi bi-exclamation-triangle-fill text-warning fs-2 mb-3"></i>
            <h6>{{ $t("accounts.modal_user_title") }}</h6>
            <p class="text-justify  px-6" style="margin: 20px auto; width: max-content">
              {{ $t("accounts.modal_admin_content") }}
            </p>
          </div>
          <div class="modal-footer border-0 mb-1 pb-5">
            <argon-button type="button" class="btn bg-transparent " data-bs-dismiss="modal"
              style="width: 150px; height: 50px; padding-top: 15px; border: 1px solid rgba(255, 255, 255, 0.4);">
              {{ $t("button.cancel") }}
            </argon-button>
            <argon-button :loading="loading" :active="buttonActive || showConfirmation" color="danger"
              variant="gradient" type="button" class="mt-1" style="width: 150px; height: 50px; padding-top: 15px"
              @click="user_user(studentToDeleteId)">
              {{ $t("button.confirm") }}
            </argon-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "../components/Spinner.vue";
import ArgonButton from "@/components/ArgonButton";
import { getMembers, memberinfo, updateMemberStatus, getinfoMembers } from "@/utils/services";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import Zoomableimage from "@/views/components/Zoomableimage.vue";

export default {
  name: "projects-table",
  data() {
    return {
      username: "",
      admin: "",
      studentToDeleteId: null,
      showConfirmation: false,
      member_id: "",
      members: [],
      loading: false,
      currentUser: {},
    };
  },

  components: { Spinner, ArgonButton, Zoomableimage },

  computed: {
    filteredMembers() {
      if (!this.currentUser.username) return this.members;
      //return this.members.filter(member => member.username !== this.currentUser.username);
      return this.members
    },
    canSeeLock() {
      return (list) => {
        if (this.currentUser.is_staff && this.currentUser.superadmin) {
          // Superadmin voit le cadenas sur tous les autres
          return true;
        } else if (this.currentUser.is_staff && !this.currentUser.superadmin) {
          // Admin classique voit le cadenas seulement sur les utilisateurs normaux
          return !list.is_staff;
        } else {
          // Utilisateur normal ne voit pas le cadenas
          return false;
        }
      };
    },
  },

  async mounted() {
    await this.fetchMembers();
    const username = localStorage.getItem('username');
    if (username) {
      try {
        this.currentUser = await getinfoMembers(username);
      } catch (error) {
        console.error("Erreur lors de la récupération des informations de l'utilisateur actuel:", error);
      }
    }
  },

  methods: {
    async fetchMembers() {
      try {
        this.loading = true;
        const result = await getMembers();

        if (result.status === 200) {
          this.members = result.data;
        } else {
          console.error("Erreur lors de la récupération des membres :", result.error);
        }
      } catch (error) {
        console.error("Erreur inattendue lors de la récupération des membres :", error);
      } finally {
        this.loading = false;
      }
    },

    openmodal(studentId) {
      this.studentToDeleteId = studentId;
    },

    async confirmBlockUser(studentId) {
      try {
        if (this.loading) {
          return;
        }
        this.loading = true;
        const updatedMember = await updateMemberStatus(studentId, { is_active: false });

        if (updatedMember) {
          this.showConfirmation = true;
          const message = this.$t("accounts.message_lock");
          toast.success(message, {
            autoClose: 3000,
          });

          setTimeout(() => {
            window.location.reload();
            this.showConfirmation = false;
          }, 3000);
        } else {
          console.error('Erreur lors du blocage du membre:', updatedMember.error);
        }
      } catch (error) {
        console.error('Erreur inattendue lors du blocage du membre:', error);
      } finally {
        this.loading = false;
      }
    },

    async confirmBlockUser1(studentId) {
      try {
        if (this.loading) {
          return;
        }
        this.loading = true;
        const updatedMember = await updateMemberStatus(studentId, { is_active: true });

        if (updatedMember) {
          this.showConfirmation = true;
          const message = this.$t("accounts.message_unlock");
          toast.success(message, {
            autoClose: 3000,
          });

          setTimeout(() => {
            window.location.reload();
            this.showConfirmation = false;
          }, 3000);
        } else {
          console.error('Erreur lors du blocage du membre:', updatedMember.error);
        }
      } catch (error) {
        console.error('Erreur inattendue lors du blocage du membre:', error);
      } finally {
        this.loading = false;
      }
    },

    internets() {
      this.internet = false;
      this.no_internet = true;
    },



    async memberinfo(id) {
      if (this.loading) {
        return;
      }
      try {
        this.loading = true;
        this.button = "disabled";
        const member_id = id;

        let data = {
          member_id
        };

        console.log(data);

        if (!member_id) {
          const message = this.$t("message.requiredfile");
          toast.info(message, {
            autoClose: 3000,
          });
          return;
        }

        if (member_id === "" || member_id === null) {
          this.required = "required";
          this.button = "";
        } else {
          let res = await memberinfo(data);

          if (!navigator.onLine) {
            const message = this.$t("message.notinternet");
            toast.error(message, {
              autoClose: 3000,
            });
          } else if (res.status === 200) {
            const message = this.$t("accounts.send_info");
            this.message = toast.success(message, {
              autoClose: 3000,
            });
          }
        }
      } catch (error) {
        console.error(error);

        if (error.response && error.response.status === 404) {
          toast.error("User not found. Please check the provided information", {
            autoClose: 3000,
          });
        } else {
          toast.error("An error occurred while creating the member", {
            autoClose: 3000,
          });
        }
      } finally {
        this.loading = false;
        this.button = "";
      }
    },

    async user_admin(studentId) {
      try {
        if (this.loading) {
          return;
        }
        this.loading = true;
        const updatedMember = await updateMemberStatus(studentId, { is_staff: true });

        if (updatedMember) {
          this.showConfirmation = true;
          const message = this.$t("accounts.message_role_changed");
          toast.success(message, {
            autoClose: 3000,
          });

          setTimeout(() => {
            window.location.reload();
            this.showConfirmation = false;
          }, 3000);
        } else {
          console.error('Erreur lors de la modification du rôle:', updatedMember.error);
        }
      } catch (error) {
        console.error('Erreur inattendue lors de la modification du rôle:', error);
      } finally {
        this.loading = false;
      }
    },

    async user_user(studentId) {
      try {
        if (this.loading) {
          return;
        }
        this.loading = true;
        const updatedMember = await updateMemberStatus(studentId, { is_staff: false });

        if (updatedMember) {
          this.showConfirmation = true;
          const message = this.$t("accounts.message_role_changed");
          toast.success(message, {
            autoClose: 3000,
          });

          setTimeout(() => {
            window.location.reload();
            this.showConfirmation = false;
          }, 3000);
        } else {
          console.error('Erreur lors de la modification du rôle:', updatedMember.error);
        }
      } catch (error) {
        console.error('Erreur inattendue lors de la modification du rôle:', error);
      } finally {
        this.loading = false;
      }
    },

  }
}
</script>

<style scoped>
/*=======css table ====*/

.card .table thead tr th {
  width: 30%;
}



.card .table tbody tr:hover td .amount {
  filter: blur(2px);

}

.card .table tbody tr {
  transition: 0.7s;
  cursor: pointer;
}

.card .table tbody tr {
  position: relative;
}

.card .table tbody tr td .content-td {
  position: absolute;
  top: 25px;


}

.action {
  display: none;
}

.card .table tbody tr:hover .action {
  display: block;
}



.pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/*=======css table ====*/
</style>
